$(document).ready(function () {
  $("#imgt-nav, #t-nav").hide();


// *********************************************************** Single page navigation style **********************************
  function updatePagination() {
    const $paginationItems = $('#dots-nav-single .page-item');
    const $activeItem = $('#dots-nav-single .page-item .nav-index.active').parent();
  
    const activeIndex = $activeItem.index();
    const totalItems = $paginationItems.length;
  
    $paginationItems.removeClass('prev next first last extra');
    $paginationItems.hide();
    let start, end;
    
    if (activeIndex <= 2) {
        start = 0;
        end = 5;
    } else if (activeIndex >= totalItems - 3) {
        start = totalItems - 5;
        end = totalItems;
    } else {
        start = activeIndex - 2;
        end = activeIndex + 3;
    }
  
    if (start < 0) {
        start = 0;
        end = 5;
    }
    if (end > totalItems) {
        end = totalItems;
        start = totalItems - 5;
    }
  
    for (let i = start; i < end; i++) {
        $paginationItems.eq(i).addClass('extra').show();
    }
  
    $activeItem.addClass('active').show();
  }




  //************************************single product nav active on loading ****************************************

  $('.product__thumb-item .product__thumb').each(function () {
    if ($(this).hasClass('is-active')) {
      var itemIndex = $(this).attr('data-index');
      // console.log(itemIndex);

      //single product nav active
      var single_pdt_nav_counts = 0;
      $('#dots-nav-single ul li .nav-index').each(function () {
        // console.log(itemIndex);
        if (single_pdt_nav_counts == itemIndex) {
          $('#dots-nav-single ul li .nav-index').removeClass('active');
          // console.log(single_pdt_nav_count);
          $(this).addClass('active');
        }
        single_pdt_nav_counts++;
      });



    }
  });

  // ************************************************* on click dot navigation ***************************************************************
  $("#dots-nav").click(function () {


    $(this).hide();
    $("#imgt-nav, #t-nav").show();
    // $("#nav-home-tabimg").addClass("active");
    $(".nav-link").eq(1).addClass('active');
    $("#t-nav .nav-toggle-mainnav .nav-link").eq(1).addClass('show active');
    $("#t-nav .tab-pane.content-panel").eq(1).addClass('show active');
    var first_nav = $(".nav-link").eq(1).find('ul.t-paginationlist li.t-pagination');
    if (first_nav) {
      var firstLi = $(".nav-link").eq(1).find('ul li.t-pagination').first();
      $(".nav-link").eq(1).find('ul').removeClass('d-none');
      if (firstLi.length) {
        firstLi.addClass("active");
        firstLi.click();
      }
    }

    let count = 0;
    $('#imgt-nav .nav-index').each(function () {
      if ($(this).hasClass('active')) {
        return false; // Break the loop
      }
      count++;
    });
    // console.log(count);
    let thumbElement = document.getElementById('product-thumb-' + count);
    if (thumbElement) {
      thumbElement.click();
    } else {
      // console.error('Element with ID product-thumb-' + count + ' not found.');
    }

  });




  // ************************************* on click pagination along with icons ***********************************************************

  $('.t-paginationlist').on('click', 'li.t-pagination', function () {
    $('ul.t-paginationlist li.t-pagination').removeClass('active');

    $(this).closest('button').find('ul.t-paginationlist li.t-pagination').removeClass('active');
    $(this).addClass('active');
    let count = 0;
    $('#imgt-nav .nav-index').each(function () {
      if ($(this).hasClass('active')) {
        return false; // Break the loop
      }
      count++;
    });
    // console.log(count);

    let thumbElement = document.getElementById('product-thumb-' + count);
    if (thumbElement) {
      thumbElement.click();
    } else {
      // console.error('Element with ID product-thumb-' + count + ' not found.');
    }
  });




  // ************************************************** on click icons ************************************************************
  $("#imgt-nav .nav-link img").click(function () {
    $("ul.t-paginationlist li.t-pagination").removeClass('active');
    $("#imgt-nav .nav-link").removeClass('active');
    $(this).parent('.nav-link').addClass('active');
    $(".nav-link").find('ul').addClass('d-none');
    $(this).siblings('ul').removeClass('d-none');
    $("#imgt-nav .nav-link").siblings('ul').find('li').removeClass('active');

    $(this).siblings('ul').find('li').removeClass('active');
    var firstLi = $(this).siblings('ul').find('li.t-pagination.nav-index').first();
    if (firstLi.length) {
        firstLi.addClass('active');
    }

});

$("#imgt-nav .nav-link").click(function () {
    $('#t-nav .nav-toggle-mainnav .nav-link').removeClass('show active');
    var activeicon = $(this).attr('data-bs-target');
    $('#t-nav .nav-toggle-mainnav .nav-link').each(function () {
        var t_nav_attr = $(this).attr('data-bs-target');
        if (t_nav_attr == activeicon) {
            $(this).addClass('show active');
        }
    });

    var firstLi = $(this).closest('button').find('ul.t-paginationlist li.t-pagination');
    if (firstLi.length == 0) {
        $('ul.t-paginationlist li.t-pagination').removeClass('active');
    } else {
        $(this).closest('ul.t-paginationlist').find('li.t-pagination').first().addClass('active');
        $(this).closest('ul.t-paginationlist').find('li.t-pagination').first().click();
    }

    let count = 0;
    $('#imgt-nav .nav-index').each(function () {
        if ($(this).hasClass('active')) {
            return false; // Break the loop
        }
        count++;
    });
    let thumbElement = document.getElementById('product-thumb-' + count);
    if (thumbElement) {
        thumbElement.click();
    } else {
        // console.error('Element with ID product-thumb-' + count + ' not found.');
    }
});



  // ******************************************************************  image thumb click  **************************************************
  $('.product__thumb-item .product__thumb').click(function () {
      
// Single productpage description section
$("#t-navs").removeClass("d-none");
if($("#product-thumb-0").hasClass('is-active')){
  $("#t-navs").addClass("d-none");
}
// console.log($(this).attr('data-index'));
    $(".nav-link").find('ul').addClass('d-none');

    setTimeout(function () {
      if ($('#nav-home-tabimg').hasClass('active')) {
        $("#dots-nav").show();
        $("#imgt-nav").hide();
      }
    }, 100);



    // to add active to image nav
    $("#dots-nav").hide();
    $("#imgt-nav, #t-nav").show();


    if ($(this).hasClass('is-active')) {
      var itemIndex = $(this).attr('data-index');
      // console.log("Item index:", itemIndex);


      // to hide all content in t-nav
      if (itemIndex == 0) {
        var element = $('#t-nav');
        element.css('display', 'none');
      }

      var count = 0;

      $('#imgt-nav .nav-index').each(function () {
        if (count == itemIndex) {

          $('#imgt-nav .nav-index').removeClass('active');
          $('#t-nav .nav-index').removeClass('show active');
          $(this).addClass('active');


          // add active to rightside tab
          var firstLi = $(this).hasClass('t-pagination');
          if (firstLi) {
            $(this).closest('button').find('ul').removeClass('d-none');
            $('#imgt-nav .nav-index').closest('button').removeClass('active');
            var active_btn_attr = $(this).closest('button').attr('data-bs-target');
            $(this).closest('button').addClass('active');
            $("#t-nav " + active_btn_attr + "-tab").addClass('show active');
            $("#t-nav .tab-pane.content-panel" + active_btn_attr).addClass('show active');
          } else {
            $(this).siblings('ul').addClass('d-none');

            $('#imgt-nav .nav-index.t-pagination').closest('button').removeClass('active');

            var t_nav_attr = $(this).attr("data-bs-target");
            // console.log("Target attribute:", t_nav_attr); // Added log
            $("#t-nav " + t_nav_attr + "-tab").addClass('show active');
            $("#t-nav .tab-pane.content-panel" + t_nav_attr).addClass('show active');
          }
        }
        count++;
      });

      //single product nav active
      var single_pdt_nav_count = 0;
      $('#dots-nav-single ul li .nav-index').each(function () {
        // console.log(itemIndex);
        if (single_pdt_nav_count == itemIndex) {
          $('#dots-nav-single ul li .nav-index').removeClass('active');
          // console.log(single_pdt_nav_count);
          $(this).addClass('active');
        }
        single_pdt_nav_count++;
      });

    }
  });






  // **************************************************** Navigation Button **************************************************************
  $('.flickity-button').click(function () {
// Single productpage description section
$("#t-navs").removeClass("d-none");
if($("#product-thumb-0").hasClass('is-active')){
  $("#t-navs").addClass("d-none");
}
    $(".nav-link").find('ul').addClass('d-none');


    setTimeout(function () {
      if ($('#nav-home-tabimg').hasClass('active')) {
        $("#dots-nav").show();
        $("#imgt-nav").hide();
      }
    }, 100);

    $("#dots-nav").hide();
    $("#imgt-nav, #t-nav").show();

    $('.product__thumb-item .product__thumb').each(function () {
      if ($(this).hasClass('is-active')) {
        var itemIndex = $(this).attr('data-index');
        // console.log(itemIndex);


        // to hide all content in t-nav
        if (itemIndex == 0) {
          var element = $('#t-nav');
          element.css('display', 'none');
        }


        var count = 0;
        $('#imgt-nav .nav-index').each(function () {
          if (count == itemIndex) {
            $('#imgt-nav .nav-index').removeClass('active');
            $(this).addClass('active');

            $('#t-nav .nav-index').removeClass('show active');
            var firstLi = $(this).hasClass('t-pagination');
            if (firstLi) {
              $(this).closest('button').find('ul').removeClass('d-none');

              $('#imgt-nav .nav-index').closest('button').removeClass('active');
              var active_btn_attr = $(this).closest('button').attr('data-bs-target');
              $(this).closest('button').addClass('active');

              $("#t-nav " + active_btn_attr + "-tab").addClass('show active');
              $("#t-nav .tab-pane.content-panel" + active_btn_attr).addClass('show active');
            } else {
              $(this).siblings('ul').addClass('d-none');

              $('#imgt-nav .nav-index.t-pagination').closest('button').removeClass('active');

              var t_nav_attr = $(this).attr("data-bs-target");
              // console.log("Target attribute:", t_nav_attr); // Added log
              $("#t-nav " + t_nav_attr + "-tab").addClass('show active');
              $("#t-nav .tab-pane.content-panel" + t_nav_attr).addClass('show active');
            }
          }
          count++;
        });



        // single-product navigation 
        var single_pdt_nav_count = 0;
        $('#dots-nav-single ul li .nav-index').each(function () {
          // console.log(itemIndex);
          if (single_pdt_nav_count == itemIndex) {
            $('#dots-nav-single ul li .nav-index').removeClass('active');
            // console.log(single_pdt_nav_count);
            $(this).addClass('active');
          }
          single_pdt_nav_count++;
        });
      }
    });



  });

  // ******************************************* On Swipe ************************************************************************

  var flkty = new Flickity('.product-slideshow', {
    cellAlign: 'left',
    contain: true
  });



  flkty.on('change', function (index) {

    // Single productpage description section
    $("#t-navs").removeClass("d-none");
    if($("#product-thumb-0").hasClass('is-active')){
      $("#t-navs").addClass("d-none");
    }
    $(".nav-link").find('ul').addClass('d-none');

    $("#dots-nav").hide();
    $("#imgt-nav, #t-nav").show();

    setTimeout(function () {
      if ($('#nav-home-tabimg').hasClass('active')) {
        $("#dots-nav").show();
        $("#imgt-nav").hide();
      }
    }, 100);



    $('.product__thumb-item .product__thumb').each(function () {
      if ($(this).hasClass('is-active')) {
        var itemIndex = $(this).attr('data-index');

        // to hide all content in t-nav
        if (itemIndex == 0) {
          var element = $('#t-nav');
          element.css('display', 'none');
        }
        // console.log(itemIndex);
        var count = 0;
        $('#imgt-nav .nav-index').each(function () {
          if (count == index) {
            $('#imgt-nav .nav-index').removeClass('active');
            $(this).addClass('active');



            $('#t-nav .nav-index').removeClass('show active');
            var firstLi = $(this).hasClass('t-pagination');
            if (firstLi) {
              $(this).closest('button').find('ul').removeClass('d-none');

              $('#imgt-nav .nav-index').closest('button').removeClass('active');
              var active_btn_attr = $(this).closest('button').attr('data-bs-target');
              $(this).closest('button').addClass('active');
              $("#t-nav " + active_btn_attr + "-tab").addClass('show active');
              $("#t-nav .tab-pane.content-panel" + active_btn_attr).addClass('show active');
            } else {
              $(this).siblings('ul').addClass('d-none');

              // setTimeout(function() {
              //   $('#t-nav .nav-index').each(function () {
              //     if ($(this).hasClass('nav_all')) {
              //     var element = $('#t-nav');
              //       element.css('display', 'none');

              //   }
              // })
              // }, 100); 

              $('#imgt-nav .nav-index.t-pagination').closest('button').removeClass('active');
              var t_nav_attr = $(this).attr("data-bs-target");
              // console.log("Target attribute:", t_nav_attr); // Added log
              $("#t-nav " + t_nav_attr + "-tab").addClass('show active');
              $("#t-nav .tab-pane.content-panel" + t_nav_attr).addClass('show active');
            }
          }
          count++;
        });



        // single-product navigation 
        var single_pdt_nav_count = 0;
        $('#dots-nav-single ul li .nav-index').each(function () {
          // console.log(itemIndex);
          if (single_pdt_nav_count == itemIndex) {
            $('#dots-nav-single ul li .nav-index').removeClass('active');
            // console.log(single_pdt_nav_count);
            $(this).addClass('active');
          }
          single_pdt_nav_count++;
        });
        // updatePagination();

      }
    });
    // updatePagination();

  });

  // ************************************************************* t-nav click active ***********************************************************

  $('#t-nav .nav-index').click(function () {

    // to hide all content in t-nav
    if ($(this).hasClass('nav_all')) {
      var element = $('#t-nav');
      setTimeout(function () {
        element.css('display', 'none');
      }, 100); // Change 1000 to the desired delay in milliseconds
    }


    var t_nav_attr = $(this).attr('data-bs-target');
    $('#imgt-nav .nav-link').each(function () {
      var img_nav_attr = $(this).attr('data-bs-target');
      if (t_nav_attr == img_nav_attr) {

        // add active to image nav 
        var firstLi = $(this).find('ul li.t-pagination').first();
        if (firstLi.length) {
          firstLi.addClass("active");
          firstLi.click();
        } else {
          var img_nav_id = $(this).attr('id');
          let thumbElement = document.getElementById(img_nav_id);
          // console.log("Thumbnail element: ", thumbElement);
          if (thumbElement) {
            thumbElement.click();
            // console.log("Thumbnail clicked");
          } else {
            // console.error('Element with ID ' + img_nav_id + ' not found.');
          }
        }
      }
    });
  });






  // ********************************************** single product page  dot nav active ***************************************************
  $('#dots-nav-single ul li .nav-index').click(function () {

    // Single productpage description section
    $("#t-navs").removeClass("d-none");
    if($("#product-thumb-0").hasClass('is-active')){
      $("#t-navs").addClass("d-none");
    }
    var dot_nav_index = $(this).attr('data-index');
    // console.log(dot_nav_index);
    $('.product__thumb-item .product__thumb').each(function () {
      var thumb_id = $(this).attr('id');
      // console.log(thumb_id);
      if ("product-thumb-" + dot_nav_index == thumb_id) {
        let thumbElement = document.getElementById(thumb_id);
        // console.log("Thumbnail element: ", thumbElement);
        if (thumbElement) {
          thumbElement.click();
          // console.log("Thumbnail clicked");
        } else {
          // console.error('Element with ID ' + img_nav_id + ' not found.');
        }
      }

    });
    // updatePagination();

  })
  // updatePagination();

  

//  To hide dot nav and show image nav
  $('#nav-home-tabimg').click(function () {
    $("#dots-nav").show();
    $("#imgt-nav").hide();
  });



});
if(window.innerWidth <= 768){
  if (window.location.href === "https://fpro.com/products/fpro-promax-elite-football" || window.location.href === "https://fpro.com/products/grip-socks-set-of-5" || window.location.href === "https://fpro.com/products/fpro-training-program" ) {
    document.getElementById('nav-tabContent-toggle').classList.add('products-padding-style');
  }
  
}




